var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionAltitudeMin16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.968 9a1 1 0 0 1-.768-.36L9.17 6.204A.734.734 0 0 1 9.734 5H11V3a1 1 0 1 1 2 0v2h1.266a.734.734 0 0 1 .564 1.204L12.8 8.64a1 1 0 0 1-.768.36h-.064Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.752 6.432 3.196 5.478c.016.029.029.059.038.09H14a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h.014a.383.383 0 0 1 .038-.09l3.196-5.478a.87.87 0 0 1 1.504 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionAltitudeMin16);
export default __webpack_public_path__ + "static/media/ic_action_altitude_min_16.81371de595874089a4e0222b1a642fce.svg";
export { ForwardRef as ReactComponent };